/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

    if (window.location.pathname.endsWith('/sitemap')) {
        // Add the title tag
        $('head').append('<title>Sitemap | Rejuvco</title>');
	}

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

    setTimeout(function() {
        $('iframe:not([title])').each(function() {
            $(this).attr('title', 'reCaptcha');
            // Additional actions if needed
        });
    }, 3000);
	


}); 


const baseUrl = 'https://rejuvco.com/search?type=product&q=';
const searchForms = document.querySelectorAll('.search-form');
const newSearches = document.querySelectorAll('.product-search');
const searchSubmits = document.querySelectorAll('.search-submit');

function openSearchUrl(event) {
    const form = event.target.closest('.search-form');
    const searchInput = form.querySelector('.product-search');
    const query = searchInput.value.trim();
    if (query !== '') {
        const newUrl = baseUrl + encodeURIComponent(query);
        window.open(newUrl, '_self');
    } else {
        // Handle empty search
        alert('Please enter a search term.');
    }
    event.preventDefault(); // Prevent default form submission behavior
}

searchForms.forEach(form => {
    form.addEventListener("submit", openSearchUrl);
});

newSearches.forEach(search => {
    search.addEventListener("keypress", function(event) {
        if (event.key === "Enter") {
            openSearchUrl(event);
        }
    });
});

searchSubmits.forEach(submit => {
    submit.addEventListener("click", openSearchUrl);
});



